/**
 * The access-token slot every tab and widget shares: localForage's localStorage driver
 * under the `whitelabel` name, so the key is `whitelabel/token` and the value a JSON
 * string literal. Kept dependency-free so the entry point can read it before anything
 * else loads.
 */
export const TOKEN_SLOT_KEY = 'whitelabel/token';

/** The id_token's slot, kept by localForage the same way as the access token's. */
export const ID_TOKEN_SLOT_KEY = 'whitelabel/id_token';

/**
 * The access token as `getToken()` returns it, read synchronously. Identity and
 * fingerprint comparisons need the value rather than its serialised form, and both
 * sides of a comparison must use the same one.
 */
export function getTokenSyncParsed(): string {
  return readSlot(TOKEN_SLOT_KEY);
}

/** The id_token as `getIdToken()` returns it, read synchronously. */
export function getIdTokenSyncParsed(): string {
  return readSlot(ID_TOKEN_SLOT_KEY);
}

function readSlot(key: string): string {
  let raw: string | null;
  try {
    raw = localStorage.getItem(key);
  } catch {
    return '';
  }
  if (!raw) return '';
  try {
    const parsed: unknown = JSON.parse(raw);
    return typeof parsed === 'string' ? parsed : '';
  } catch {
    return '';
  }
}
